import React from "react"
import { ChevronLeftIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"

/**
 * The close icon of a dialog that is a page of its own on a phone: a back
 * chevron there (the button sits top left), the usual X from md up (top
 * right). For the Modal's `closeIcon` with the sf_dialog_back variant.
 */
export default function BackOrCloseIcon({ className = "" }) {
  return (
    <>
      <ChevronLeftIcon className={twMerge(className, "md:hidden")} />
      <XMarkIcon className={twMerge(className, "hidden md:block")} />
    </>
  )
}
